import dayjs from "dayjs";

export const parseScheduleDrawer = (data: any[]): any[] => {
  const res = [];

  for (const item of data) {
    res.push({
      "pedido-id": item.id,
      "pedido-centro": item.storeId,
      "pedido-fornecedor-codigo": item.supplierProductCode,
      "pedido-fornecedor": item.descriptionSupplier,
      "pedido-setor": item.categoryCompact,
      "pedido-codigo": item.productId,
      "pedido-produto": item.productDescription,
      "pedido-pedido": item.documentId,
      "quantidade-total": item.orderedQuantity,
      "quantidade-entregue": item.receivedQuantity,
      "quantidade-pendente": item.pendingQuantity,
      "quantidade-agendada": item.schedulingQuantity,
      "data-agendada": dayjs(item.schedulingDate).format("DD/MM/YYYY "),
      "data-prevista": dayjs(item.expectativeDate).format("DD/MM/YYYY "),
    });
  }

  return res;
};
